
import React from 'react';
import { Button } from '@/components/ui/button';
import { Users, PlusCircle } from 'lucide-react';

interface EmptyFamilyStateProps {
  onCreateFamily: () => void;
}

const EmptyFamilyState = ({ onCreateFamily }: EmptyFamilyStateProps) => {
  return (
    <div className="flex flex-col items-center justify-center py-8 space-y-4">
      <Users className="h-12 w-12 text-muted-foreground" />
      <div className="text-center">
        <h3 className="font-medium text-lg">No Family Group</h3>
        <p className="text-muted-foreground mt-1 mb-4">
          Create a family group to share your children's quotes and milestones with loved ones
        </p>
        <Button
          onClick={onCreateFamily}
          className="flex items-center gap-2 mx-auto"
        >
          <PlusCircle className="h-4 w-4" />
          Create Family
        </Button>
      </div>
    </div>
  );
};

export default EmptyFamilyState;
